import React from "react";
import { Link } from "react-router-dom";

const MobileMenu = ({ menuOpen, toggleMenu }) => {
  return (
    <nav
      id="navmenu"
      className={`navmenu ${menuOpen ? "active" : ""}`}
      style={{
        display: menuOpen ? "block" : "none",
        position: "fixed",
        top: "0",
        left: "0",
        right: "0",
        backgroundColor: "#fff",
        zIndex: "1000",
      }}
    >
      <button 
        onClick={toggleMenu}
        style={{
          position: "absolute",
          right: "15px",
          top: "15px",
          background: "none",
          border: "none",
          fontSize: "24px",
          cursor: "pointer"
        }}
      >
        <i className="bi bi-x-lg"></i>
      </button>

      <ul>
        <li>
          <Link to={"/student/dashboard"} onClick={toggleMenu}>
            <i className="bi bi-house navicon"></i>
            <span>Dashboard</span>
          </Link>
        </li>
        <li>
          <Link to={"my-library"} onClick={toggleMenu}>
            <i className="bi bi-hdd-stack navicon"></i>
            <span>My Library</span>
          </Link>
        </li>
        <li>
          <Link to={"my-vocabulary"} onClick={toggleMenu}>
            <i className="bi bi-card-list"></i>
            <span>My Notebook</span>
          </Link>
        </li>
        {localStorage.getItem("courseType") === "Non-Test Based" && (
          <>
            <li>
              <Link to={"grammar-book"} onClick={toggleMenu}>
                <i className="bi bi-book"></i>
                <span>My Grammar Book</span>
              </Link>
            </li>
            <li>
              <Link to={"my-answers"} onClick={toggleMenu}>
                <i className="bi bi-check2-circle"></i>
                <span>My Answers</span>
              </Link>
            </li>
            <li>
              <Link to={"feedbacks"} onClick={toggleMenu}>
                <i className="bi bi-chat-dots"></i>
                <span>Feedbacks</span>
              </Link>
            </li>
          </>
        )}
      </ul>
    </nav>
  );
};

export default MobileMenu;
